import { AfterViewInit, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { ConfirmDialogComponent } from '../confirm-dialog.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-listing-dialog',
  templateUrl: './listing-dialog.component.html',
  styleUrls: ['./listing-dialog.component.scss']
})
export class ListingDialogComponent implements OnInit, AfterViewInit {

  itemsPerPage: number = 20;
  currentPage: number = 1;
  totalCounts: number = 0;
  clientList: any[] = [];
  searchString: string = '';
  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<ListingDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService,
    private service: PagesService, private router: Router, private loader: NgxUiLoaderService) { }

  ngOnInit(): void {
    if (this.data?.video) {
      this.totalCounts = this.data.video.length;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.data?.phoneNumber)
        this.getClientList();
    }, 0)
  }

  loading: boolean = false;
  totalPages: number = 100;
  getClientList() {
    const data = {
      pageIndex: this.currentPage,
      limit: this.itemsPerPage,
      search: this.searchString,
      twilioCase: 1
    }
    if (this.currentPage > this.totalPages) return;
    this.loading = true;
    this.loader.start();
    this.service.get(data, `${API_ROUTES.CLIENT.getClientList}`).pipe().subscribe((response: any) => {
      this.loader.stop();
      if (response.status) {
        this.clientList = [...this.clientList, ...response.data.list];
        this.totalCounts = response.data.count;
        this.totalPages = Math.ceil(this.totalCounts / this.itemsPerPage);
        this.loading = false;
      } else {
        this.totalCounts = 0;
      }
    })
  }

  // For the entire window
  @HostListener('scroll', ['$event'])
  onWindowScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 100) {
      if (!this.loading) {
        this.currentPage++;
        this.getClientList(); // Load more items when close to the bottom
      }
    }
  }

  pageChanged(event: any) {
    this.currentPage = event
    this.getClientList()
  }

  filterSelection(event: any) {
    this.searchString = event;
    this.currentPage = 1;
    this.clientList = [];
    this.getClientList();
  }

  addPhoneNumber(client: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxHeight: '100vh',
      width: '550px',
      data: {
        img: ``,
        title: `Are you sure you want to assign this number?`,
        sayYes: `Assign`,
        sayNo: `Cancel`,
        btnColor: 'blue',
      }
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        let payload = {}
        let url;
        if (this.data.currentStatus == 0) {
          url = `${API_ROUTES.CLIENT.updatePhoneNumber}`
          payload = {
            companyId: client.companyId,
            phoneNumber: this.data.phoneNumber
          }
        } else {
          url = `${API_ROUTES.CLIENT.reassignNumber}`
          payload = {
            newCompanyId: client.companyId,
            phoneNumber: this.data.phoneNumber.phoneNumber
          }
          if (!this.data.phoneNumber.companyId) {
            url = `${API_ROUTES.CLIENT.updatePhoneNumber}`
            payload = {
              companyId: client.companyId,
              phoneNumber: this.data.phoneNumber.phoneNumber
            }
          }
        }
        this.loader.start();
        this.service.post(payload, url).subscribe((res) => {
          this.loader.stop();
          if (res.status) {
            this.toastr.success(res.msg);
            this.dialogRef.close(true);
          } else {
            this.toastr.error(res);
          }
        },
          (err: any) => {
            this.toastr.error(err.msg);
          })
      }
    });
  }


  dropEstimate(event: CdkDragDrop<any>, type: any) {
    moveItemInArray(this.data.video, event.previousIndex, event.currentIndex);
  }

  saveVideoOrder() {
    const payload = this.data?.video.map((v, i) => ({ id: v._id, order: i + 1 }));
    this.dialogRef.close(payload);
  }
}
